import * as React from 'react';
import { BlogDetailHeader, BlogIntro } from '@grandvisionhq/content';
import { useIntl } from '@grandvisionhq/state';
import '../containers/Accordion/Accordion.js';
import '../containers/Article/Article.js';
import '../containers/ArticleCollection/ArticleCollection.js';
import '../containers/Banner/Banner.js';
import '../containers/BannerCollection/BannerCollection.js';
import '../containers/BlogCollection/BlogCollection.js';
import '../containers/BlogOverview/BlogOverview.js';
import '../containers/BrandCollection/BrandCollection.js';
import '../containers/BrandList/BrandList.js';
import '../containers/Carousel/Carousel.js';
import '@bloomreach/react-sdk';
import CmsContentBlocks from '../containers/ContentBlocks/ContentBlocks.js';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import '@grandvisionhq/utils';
import '@swc/helpers';
import '../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '../utils/http-client.js';
import { parseBloomreachImage } from '../utils/parse-bloomreach-image.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/graphql';
import '../operations/mutations/signup-promotion.js';
import '../operations/mutations/subscribe-newsletter.js';
import '../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../hooks/use-breakpoint-visibility.js';
import '../containers/CountdownTimer/CountdownTimer.js';
import '../containers/Document/Document.js';
import '../containers/Faq/Faq.js';
import '@grandvisionhq/layout';
import '../containers/GroupedCards/GroupedCards.js';
import '@grandvisionhq/analytics';
import '@grandvisionhq/auth';
import '@grandvisionhq/frk-routing';
import '../containers/Heading/Heading.js';
import '../containers/IconList/IconList.js';
import '../containers/Iframe/Iframe.js';
import '../containers/LinkList/LinkList.js';
import '../containers/Newsletter/Newsletter.js';
import '../containers/NewsletterBanner/NewsletterBanner.js';
import '../containers/TryInStoreBanner/TryInStoreBanner.js';
import '../containers/NotificationBar/NotificationBar.js';
import '../containers/PolicyBar/PolicyBar.js';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/products';
import '../containers/Breadcrumbs/Breadcrumbs.js';
import '../containers/ProductCatalog/ProductCatalog.js';
import '../containers/Promotion/Promotion.js';
import '../containers/RecentlyViewedProducts/RecentlyViewedProducts.js';
import '../containers/RichText/RichText.js';
import '../containers/Video/Video.js';
import '../containers/Widget/Widget.js';
import '../containers/WidgetTrustedShop/WidgetTrustedShop.js';
import '../containers/Whitespace/Whitespace.js';
import '../containers/SpotlightedStores/SpotlightedStores.js';
import '../containers/FixedCta/FixedCta.js';
import '../containers/Button/Button.js';
import '../containers/GlobalContactForm/GlobalContactForm.js';
import 'classnames';
import '../containers/RowComponent/RowText/RowText.js';
import '../containers/RowComponent/RowProductListBySku/RowProductListBySku.js';
import { withEditableContent } from '../hocs/with-editable-content.js';

const CmsBlogLayout = ({ content  })=>{
    const { getLabel , locale  } = useIntl();
    const { title , summary , coverImage , publishDate , readingTime , contentBlocks  } = content;
    const image = parseBloomreachImage(coverImage);
    return /*#__PURE__*/ React.createElement("div", {
        className: "blog-layout"
    }, image && /*#__PURE__*/ React.createElement(BlogDetailHeader, {
        title: title,
        image: image.original,
        mobileImage: image.mobile,
        scrollTo: "blog-content-start"
    }), summary && /*#__PURE__*/ React.createElement(BlogIntro, {
        locale: locale,
        summary: summary,
        publishDate: publishDate,
        readingTime: readingTime,
        minutesLabel: getLabel('blog.minutesToRead')
    }), /*#__PURE__*/ React.createElement("article", {
        className: "blog-content",
        id: "blog-content-start"
    }, contentBlocks.length > 0 && /*#__PURE__*/ React.createElement(CmsContentBlocks, {
        contentBlocks: contentBlocks
    })));
};
var CmsBlogLayout$1 = withEditableContent(CmsBlogLayout);

export { CmsBlogLayout, CmsBlogLayout$1 as default };
//# sourceMappingURL=Blog.js.map
